<template>
<affix-modal>
  <div class="header_container">
    <div class="header_nav">
      <div @click="goToIndex" style="cursor:pointer;" class="header_nav_left">
        <img src="../../assets/logo.png" />
      </div>
      <div class="head_nav_center">
        <div class="head_nav_center-content">
          <input v-model="keyword" class="head_nav_center-text" type="text" @keydown="handelInput" placeholder="视频关键词" />
           <span v-if="keyword" class="head_nav_center-search head_nav_center-cancel" @click="clear" >
            <img src="../../assets/icon-qxjr.png"/>
          </span>
          <span class="head_nav_center-search" @click="searchFun" >
            <img src="../../assets/search.png"/>
          </span>
         
        </div>
      </div>
      <div class="header_nav_right">
        <div class="header_nav-item">
          <a href="#" @click="goToResouce()">版权资源库</a>
        </div>
        <div class="header_nav-item" v-if="userRole === '版权方'">
          <router-link :to="{name:'addNew'}">新增版权</router-link>
        </div>
        <div class="header_nav-item" v-if="userRole === '自媒体'">
          <div v-if="newBallNumber!=0" class="ballnew">{{newBallNumber>99?'99+':newBallNumber}}</div>
          <router-link :to="{name:'shopcart'}">版权购物车</router-link>
        </div>
        <div>
          <div class="header_nav-login" v-if="!ifLogin">
            <p @click="showLoginModal" class="header_nav-login-text">登录</p>
          </div>
          <div class="header_userInfo" v-else>
            <el-popover
              placement="bottom"
              width="174"
              trigger="hover"
              popper-class="login-pop-box"
              content="">
              <div slot="reference">
                <p>{{userInfo.companyName || userInfo.nickName || userInfo.username}}</p>
                <img class="header_userInfo_avatar" :src="userIcon"/>
                <img class="header_userInfo_1" src="../../assets/sanjiao.png" />
              </div>
              <div v-if="!!userRole" class="login-pop" @click="goToCenter">
                <!-- <p>个人中心-{{userRole}}</p>   -->
                <p>个人中心</p>
              </div>
              <div class="login-pop" @click="logout">
                <p>退出</p>  
              </div>
            </el-popover>
          </div>
          <login-modal v-show="showLogin" @hiddenFun="hiddenLoginModal" :showRole="role"></login-modal>
        </div>
      </div>
    </div>
  </div>
  </affix-modal>
</template>
<script>
import Cookies from "js-cookie";
import AffixModal from "../../components/affix/index"
import axios from "axios"
import {toLogout} from "../../api/login"
import {API_ROOT, getRequest} from "../../libs/axios"
import LoginModal from '../../components/login/index'
import userIcons from "../../assets/icon-user.png"
import {getStore, removeStore} from "../../libs/storage"
import EventBus from "../../libs/eventBus"
import {getCarList} from "../../api/shopcart"
export default {
  data() {
    return {
      ifLogin: false,
      keyword: '',
      showLogin: false,
      userInfo: {},
      userIcon: userIcons,
      role: 1,
      userRole:'',
      newBallNumber:0,
    }
  },
  
  components:{
    LoginModal,
    AffixModal
  },
  created(){
    let asa = 0
    EventBus.on('addSuccess',(aaa)=>{
     this._getCarList()
    })
  },
  mounted() {
   
  },
  computed(){
    init()
  },
  watch:{
    $route( to , from ){   
       if(to.name === 'resource') {
         
       }
       
     }
  },
  mounted(){
    this.init()
    this._getCarList()
  },
  methods: {
    _getCarList(){
      getCarList().then(res=>{
        if(res.success){
          this.newBallNumber = res.result && res.result.length!=0 ?res.result.length:0
        }
      })
    },
    init(){
      let userInfo = getStore('userInfo')
      if(userInfo){
        const _userInfo = JSON.parse(userInfo)
        this.ifLogin = true
        this.userInfo = _userInfo
        this.userIcon = _userInfo.avatar && _userInfo.avatar!="undefined"?_userInfo.avatar:this.userIcon
        const _roles = _userInfo.roles[_userInfo.roles.length-1].name
        this.role = !!_userInfo.id&& _userInfo.roles&&(_roles !== 'ROLE_MEDIA' && _roles !== 'ROLE_COPYRIGHT') ? 0 : 1
        this.userRole = _roles === "ROLE_MEDIA" ? "自媒体" : _roles === "ROLE_COPYRIGHT" ? "版权方" : ''
        if(_userInfo.roles&&(_roles !== 'ROLE_MEDIA' && _roles !== 'ROLE_COPYRIGHT')){
          this.showLoginModal()
        }
      } else {
        this.ifLogin = false
        this.showLogin = false
      }
    },
    handelFocus(){
      if(window.location.hash.lastIndexOf('resource') < 0) {
        this.$router.push({path:'resource'})
      }
      console.log(window.location.hash);
    },
    handelInput(e){
      var theEvent = e || window.event;
      var code = theEvent.keyCode || theEvent.which || theEvent.charCode;
      if(code == 13){
        this.searchFun()
      }
    },
    clear(){
      this.keyword = ''
      this.searchFun()
    },
    searchFun(){
      this.$store.commit('SET_KEYWORD', this.keyword)
      this.$router.push({name:'resource',param: {keyword: this.keyword}})
    },
    goToCenter(){
      const link = this.userRole === "版权方" ? '/mycopyrightcenter/myCopyrighWorks' :'/mycenter/myworks'
      this.$router.push(link)
    },
    goToCart(){},
    goToIndex(){
      window.location.href="/"
    },
    goToResouce(){
      this.$router.push('/resource')
    },
    logout(){
      toLogout().then(res => {
        Cookies.remove('userInfo')
        removeStore('userInfo')
        removeStore('accessToken')
        window.location.href = "/"
      })
    },
    showLoginModal(){
      console.log('..')
      this.showLogin = true
    },
    hiddenLoginModal(){
      this.showLogin = false
    }

    
  }
}

</script>
<style lang="stylus">
    .ballnew{
      position absolute
      background red
      top -10px
      right 7px
      font-size 8px
      border-radius 50%
      width 18px
      text-align center
      display flex
      justify-content center
      align-items center
    }
    .header_container{
      height 80px
      width 100vw
      background #000000
      .header_nav{
        width 1334px
        height 80px
        background black
        margin 0 auto
        display flex
        align-items center
        justify-content space-between
      }
      .header_nav_left{
        width 217px
        height 35px
        cursor pointer
        img{
          width 100%
          height 100%
        }
      }
      .head_nav_center{
        width 403px
        height 40px
      }
      .head_nav_center-content{
        width 403px
        height 40px
        background: rgba(255,255,255,0.37);
        border-radius: 56px;
        position relative
        
        input[type=text]:focus{ border: none; }
        .head_nav_center-text{
          width 100%
          height 100%
          border-radius 56px !important
          border none !important
          padding 13px 70px 13px 23px
          box-sizing border-box
        }
        
        .head_nav_center-search{
          width 18px
          height 18px
          display block
          position absolute
          top 11px
          right 22px
          cursor pointer
          img{
            width: 17px
            height 18px
          }
          // background url('./images/search.png') no-repeat
          background-size cover
        }
        .head_nav_center-cancel{
          right 48px
        }
        .head_nav_center-text:focus{
          border none !important
          outline:none;
          box-shadow: none;
        }
      }
      .header_nav_right{
        height 26px
        width 400px
        display flex
        align-items center
        justify-content flex-end
        font-size: 16px;
        .header_nav-login-text{
          cursor pointer
          a{
            font-size: 16px;
            color: #FFFFFF; 
          }
        }
      }
      .header_nav-item{
        padding 0 20px
        position relative
        a{
          color: rgba(255,255,255,0.6);
        }
      }
      .header_nav-login{
        margin-left 20px
        color white
      }
      .header_userInfo{
        width 140px
        color white
        height 26px
        padding-left 20px
        box-sizing border-box
        cursor pointer
        >span{
          width 100%
          height 100%
          >div{
            width 100%
            height 100%
            display flex
            align-items center
            justify-content space-between
          }
        }
        p{
          width 70px
          overflow:hidden; 
          text-overflow:ellipsis; 
          white-space:nowrap; 
        }
        .header_userInfo_avatar{
          width 26px
          height 26px
        }
        .header_userInfo_1{
          width 8px
          height 5px
        }
      }
      .header_nav-item::after{
        content ""
        width 1px
        height 14px
        background white
        opacity: 0.6
        position absolute
        right 0
        top 5px
      }
    }
    /deep/ .el-popover{
      padding 0
    }

    .login-pop-box{
        padding 0 !important
        .login-pop{
          cursor pointer
          width 100%
          height 36px
          line-height 36px
          text-align left
          padding 0 19px
          font-size: 16px;
          color: #333333;
        }  
        .login-pop:hover{
          background: #FFDB00;
        }
      }

    
    
</style>



// WEBPACK FOOTER //
// src/layout/header/unHeader.vue